export const BASE_URL = "https://arke-app-main.herokuapp.com";
